import { useEffect, useState } from 'react';
import { PageSection, TextContent, Text, PageSectionVariants, FormGroup, Form, TextArea, InputGroup, Button, Alert, AlertActionCloseButton, InputGroupItem } from '@patternfly/react-core';
import { useDispatch, useSelector } from 'react-redux';

import { StoreState } from '../../store/store';
import { appConfigSelectors } from '../../store/appConfig/appConfigSlice';
import { configurationTargetSelectors } from '../../store/configurationTarget/configurationTargetSlice';
import { updateLicenseStarted } from '../../store/license/licenseSlice';
import { t } from 'i18next';

const UpdateLicense = () => {

    const dispatch = useDispatch();

    const [licenseKeyBoxValue, setLicenseKeyBoxValue] = useState('');
    const [showLicenseUpdatedAlert, setLicenseUpdatedAlert] = useState(false);

    const currentTarget = useSelector(configurationTargetSelectors.selectCurrent);
    const appConfig = useSelector(appConfigSelectors.selectAppConfig);
    const isUpdatingLicense = useSelector((state: StoreState) => state.license.isUpdatingLicense);
    const licenseUpdateError = useSelector((state: StoreState) => state.license.licenseUpdateError);

    // these are used to control showing temporal alert elements in the UI
    const successfulLicenseUpdatesCount = useSelector((state: StoreState) => state.license.successfulLicenseUpdatesCount);
    const [successfulLicenseUpdatesCountOnPageLoad] = useState(successfulLicenseUpdatesCount);

    useEffect(() => {
        // reset new license key in UI, but only run this at start
        // or after a successful license update
        setLicenseKeyBoxValue('');

        // show the alert that the license update was successful
        if (successfulLicenseUpdatesCount > successfulLicenseUpdatesCountOnPageLoad) {
            setLicenseUpdatedAlert(true);
        }
    }, [successfulLicenseUpdatesCount, successfulLicenseUpdatesCountOnPageLoad]);

    const handleUpdateLicenseClick = () => {
        if (licenseKeyBoxValue && !isUpdatingLicense) {
            dispatch(updateLicenseStarted({ newLicense: licenseKeyBoxValue, appClient: currentTarget }));
        }
    }

    return (
        <PageSection variant={PageSectionVariants.light} className="limit-width update-license-section">

            <TextContent className="content-header">
                <Text component="h2">{t('licensePage.updateLicense.title')}</Text>
            </TextContent>

            {appConfig && appConfig.showErrorsInUi && licenseUpdateError !== null && (
                <PageSection className="selectable">
                    <div data-testid="update-license-error-alert">
                        <Alert variant="danger" isInline title={t('licensePage.updateLicense.error.title')}>
                            <p>{t('licensePage.updateLicense.error.message')}</p>
                            <p>{licenseUpdateError}</p>
                        </Alert>
                    </div>
                </PageSection>
            )}

            {showLicenseUpdatedAlert && (
                <PageSection>
                    <Alert variant="success" title={t('licensePage.updateLicense.success.title')} actionClose={<AlertActionCloseButton onClose={() => setLicenseUpdatedAlert(false)} />}>
                        <p>{t('licensePage.updateLicense.success.message')}</p>
                    </Alert>
                </PageSection>
            )}

            <Form isHorizontal>
                <FormGroup
                    label="Add license key"
                    fieldId="new-license-key" >
                    <InputGroup>
                        <InputGroupItem isFill><TextArea value={licenseKeyBoxValue} onChange={(_event, v) => setLicenseKeyBoxValue(v)} resizeOrientation='vertical' id="new-license-key" data-testid="update-license-key-textarea" /></InputGroupItem>
                        <InputGroupItem><Button onClick={handleUpdateLicenseClick} data-testid="update-license-submit-button">{t('licensePage.updateLicense.action')}</Button></InputGroupItem>
                    </InputGroup>
                </FormGroup>
            </Form>

        </PageSection>
    );
}

export default UpdateLicense;
